import { db } from "../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";

export default {
  name: "DevMilestoneLogic",
  data() {
    return {
      blogPosts: [],
      loading: true,
      error: ""
    };
  },
  async created() {
    await this.fetchBlogPosts();
  },
  methods: {
    async fetchBlogPosts() {
      try {
        // Fetch all blog entries from /devBlog
        const snapshot = await getDocs(collection(db, "devBlog"));
        const postPromises = snapshot.docs.map(async (docSnap) => {
          const data = docSnap.data();
          const postId = docSnap.id;
          // data now includes: timestamp, title, description, headImage, etc.
          return { id: postId, ...data };
        });
        const resolvedPosts = await Promise.all(postPromises);

        // Sort by timestamp descending.
        resolvedPosts.sort((a, b) => {
          // If timestamp is a Firestore Timestamp, use:
          // return b.timestamp?.seconds - a.timestamp?.seconds;
          return (b.timestamp || 0) - (a.timestamp || 0);
        });

        this.blogPosts = resolvedPosts;
      } catch (err) {
        console.error("Error fetching dev blog posts:", err);
        this.error = "Error fetching dev blog posts.";
      } finally {
        this.loading = false;
      }
    }
  }
};
